import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '500+',
    label: 'реалізованих бізнес-кейсів у різних нішах'
  }, {
    value: '50+',
    label: 'запусків продуктів та виходів на нові ринки'
  }, {
    value: '1000+',
    label: 'стратегічних консультацій для підприємців і команд'
  }, {
    value: '∞',
    label: 'рішень, які допомогли бізнесам зростати керовано'
  }, {
    value: '№1',
    label: 'в Україні по створенню екосистем'
  }];
  const areas = ['Побудова маркетингових систем під ключ', 'Розвиток і навчання команд', 'Управління зростанням і масштабуванням', 'Запуск внутрішніх стартапів', 'Формування лідерських позицій на ринках'];
  return <Section className="bg-gradient-to-b from-[#0A0F2A] to-[#111835]" data-id="element-435">
      <div className="text-center mb-16" data-id="element-436">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-437">
          Навчання побудоване на практиці{' '}
          <span className="text-blue-400" data-id="element-438">ARMAR Solutions</span>
        </h2>
        <p className="text-2xl text-gray-300" data-id="element-439">
          8+ років системної роботи з бізнесами
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6 mb-16" data-id="element-440">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} data-id="element-441">
            <Card className="text-center border-blue-500/20 hover:border-blue-500/50 transition-colors h-full flex flex-col justify-center" data-id="element-442">
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-blue-400 mb-3" data-id="element-443">
                {stat.value}
              </div>
              <p className="text-xs md:text-sm text-gray-300 leading-relaxed" data-id="element-444">
                {stat.label}
              </p>
            </Card>
          </motion.div>)}
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-445">
        <div className="space-y-6" data-id="element-446">
          <h3 className="text-2xl font-bold" data-id="element-447">Що стоїть за цією програмою?</h3>
          <p className="text-gray-300 leading-relaxed" data-id="element-448">
            Програма «Шлях Лідера» створена на основі практики ARMAR Solutions —
            міжнародному холдингу. Ми спеціалізуємося на зростанні та
            цифровізації бізнесів незалежно від їхнього поточного стану чи
            масштабу.
          </p>
        </div>
        <Card className="bg-blue-900/10" data-id="element-449">
          <ul className="space-y-4" data-id="element-450">
            {areas.map((area, index) => <li key={index} className="flex items-center gap-3" data-id="element-451">
                <div className="w-2 h-2 rounded-full bg-blue-400" data-id="element-452"></div>
                <span className="text-gray-200" data-id="element-453">{area}</span>
              </li>)}
          </ul>
        </Card>
      </div>
    </Section>;
}